// extracted by mini-css-extract-plugin
module.exports = {"lds_ring":"MiniLoader_lds_ring__73IFH","primary":"MiniLoader_primary__3VkWf","white":"MiniLoader_white__cP8_Q"};